// Static content for Lavish Luxe Detailing

export const CONTACT_INFO = {
  brand: 'Lavish Luxe Detailing',
  tagline: 'Luxury • Precision • Protection',
  phone: '(314) 276-8319',
  phoneRaw: '3142768319',
  email: 'lavishluxedetail@gmail.com',
  cashapp: '$lavishluxedetail',
  cashappUrl: 'https://cash.app/$lavishluxedetail',
  area: 'St. Louis, MO & surrounding areas',
  instagram: 'lavishluxe.detail',
  instagramUrl: 'https://www.instagram.com/lavishluxe.detail',
};

// Limited-time promotion — dates are inclusive, evaluated by isPromoActive()
export const PROMO = {
  id: 'july-4',
  title: 'Fourth of July Special',
  ctaShort: '4th of July Special',
  subtitle: 'Celebrate Freedom. Ride Clean.',
  validFromLabel: '7/5',
  validToLabel: '7/12',
  validFromISO: '2026-07-05',
  validToISO: '2026-07-12',
  flyer:
    'https://customer-assets.emergentagent.com/job_showroom-perfect-1/artifacts/ua39ucvz_45672F33-142F-4826-8543-DBFE129079FE.png',
};

export const isPromoActive = (now = new Date()) => {
  const start = new Date(`${PROMO.validFromISO}T00:00:00`);
  const end = new Date(`${PROMO.validToISO}T23:59:59`);
  return now >= start && now <= end;
};

// Special packages surfaced only during the promo window
export const SPECIAL_PACKAGES = [
  {
    id: 'july-full-detail',
    name: '4th of July Full Detail Special',
    displayName: 'Full Detail Special',
    priceSedan: 70,
    priceSuv: 80,
    tagline: 'Complete inside-and-out detail. SUV & Truck +$10.',
    features: [
      'Exterior wash',
      'Wheel & tire cleaning',
      'Interior deep clean',
      'Vacuum & shampoo',
    ],
    testId: 'package-july-full',
    limited: true,
  },
  {
    id: 'july-interior-detail',
    name: '4th of July Interior Detail Special',
    displayName: 'Interior Detail Special',
    priceSedan: 40,
    priceSuv: 50,
    tagline: 'Full cabin refresh at a holiday price. SUV & Truck +$10.',
    features: [
      'Deep vacuum',
      'Dash & console cleaning',
      'Door panel wipe down',
      'Trunk cleaning',
    ],
    testId: 'package-july-interior',
    limited: true,
  },
];

export const IMAGES = {
  hero: 'https://images.pexels.com/photos/18320398/pexels-photo-18320398.jpeg',
  heroAlt:
    'https://images.unsplash.com/photo-1645400379459-f6fd3d963fd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcG9ydHMlMjBjYXIlMjBkYXJrfGVufDB8fHx8MTc4Mjk1MjM1N3ww&ixlib=rb-4.1.0&q=85',
  exteriorPolish: 'https://images.pexels.com/photos/14908957/pexels-photo-14908957.jpeg',
  interiorDetail: 'https://images.pexels.com/photos/27692895/pexels-photo-27692895.jpeg',
  premiumWash:
    'https://images.unsplash.com/photo-1607860108855-64acf2078ed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxjYXIlMjB3YXNoaW5nJTIwd2F0ZXJ8ZW58MHx8fHwxNzgyOTUyMzU3fDA&ixlib=rb-4.1.0&q=85',
  aboutStudio: 'https://images.pexels.com/photos/3806249/pexels-photo-3806249.jpeg',
  ctaBanner:
    'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?auto=format&fit=crop&w=1920&q=80',
  july4Flyer:
    'https://customer-assets.emergentagent.com/job_showroom-perfect-1/artifacts/ua39ucvz_45672F33-142F-4826-8543-DBFE129079FE.png',
};

export const GALLERY_IMAGES = [
  'https://images.pexels.com/photos/94272/sports-car-pkw-auto-vehicle-94272.jpeg',
  'https://images.pexels.com/photos/37809565/pexels-photo-37809565.jpeg',
  'https://images.pexels.com/photos/29566891/pexels-photo-29566891.jpeg',
  'https://images.pexels.com/photos/14908957/pexels-photo-14908957.jpeg',
  'https://images.pexels.com/photos/27692895/pexels-photo-27692895.jpeg',
  'https://images.unsplash.com/photo-1607860108855-64acf2078ed9?auto=format&fit=crop&w=1200&q=80',
  'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?auto=format&fit=crop&w=1200&q=80',
  'https://images.unsplash.com/photo-1621361365424-06f0e1eb5c49?auto=format&fit=crop&w=1200&q=80',
  'https://images.unsplash.com/photo-1610647752706-3bb12232b3ab?auto=format&fit=crop&w=1200&q=80',
];

export const PACKAGES = [
  {
    id: 'essential',
    name: 'Essential Shine Wash',
    priceSedan: 35,
    priceSuv: 45,
    tagline: 'Weekly refresh with a showroom finish.',
    features: ['Hand wash', 'Rinse', 'Microfiber dry', 'Wheels & tires', 'Windows'],
    testId: 'package-essential-shine',
  },
  {
    id: 'interior',
    name: 'Interior Refresh',
    priceSedan: 70,
    priceSuv: 80,
    tagline: 'Immaculate cabin, revitalised details.',
    features: [
      'Vacuum full interior',
      'Mats cleaned',
      'Dash & console',
      'Vents & cup holders',
      'Light stain removal',
    ],
    testId: 'package-interior-refresh',
  },
  {
    id: 'exterior',
    name: 'Exterior Shine Package',
    priceSedan: 45,
    priceSuv: 55,
    tagline: 'Deep clean with lasting exterior gloss.',
    features: ['Wash & dry', 'Bug & tar removal', 'Wax or sealant', 'Tire shine'],
    testId: 'package-exterior-shine',
  },
  {
    id: 'complete',
    name: 'Complete Detail Package',
    priceSedan: 115,
    priceSuv: 125,
    tagline: 'Inside and out — restored to perfection.',
    features: [
      'Full interior detail',
      'Full exterior detail',
      'Wax protection',
      'Trim shine',
      'Door jamb cleaning',
    ],
    testId: 'package-complete-detail',
    highlight: true,
  },
  {
    id: 'premium',
    name: 'Premium Detail Package',
    priceSedan: 200,
    priceSuv: 210,
    tagline: 'The signature Lavish Luxe treatment.',
    features: [
      'Clay bar treatment',
      'Machine polish',
      'Odor removal',
      'Deep stain cleaning',
      'Engine bay cleaning',
    ],
    testId: 'package-premium-detail',
  },
];

export const ADD_ONS = [
  { id: 'engine-bay', name: 'Engine Bay Cleaning', price: '$30–$40', testId: 'addon-engine-bay' },
  { id: 'headlight', name: 'Headlight Restoration', price: '$40–$50', testId: 'addon-headlight' },
  { id: 'pet-hair', name: 'Pet Hair Removal', price: '$25–$45', testId: 'addon-pet-hair' },
  { id: 'odor', name: 'Odor Removal', price: '$15–$25', testId: 'addon-odor' },
  {
    id: 'ceramic',
    name: 'Ceramic Spray Protection',
    price: '$50–$75',
    testId: 'addon-ceramic',
  },
  {
    id: 'door-jamb',
    name: 'Door Jamb Cleaning',
    price: '$10–$15',
    testId: 'addon-door-jamb',
  },
  {
    id: 'stain-removal',
    name: 'Deep Stain Removal',
    price: '$15–$25',
    testId: 'addon-stain-removal',
  },
];

export const TESTIMONIALS = [
  {
    quote: 'My car looks brand new again. The attention to detail is unmatched.',
    author: 'Marcus R.',
    location: 'Ladue, MO',
  },
  {
    quote: 'Best detailing in the area. They came to me and left my SUV showroom-ready.',
    author: 'Danielle W.',
    location: 'Clayton, MO',
  },
  {
    quote: 'Professional, punctual, and worth every dollar. I will not go anywhere else.',
    author: 'Jamal T.',
    location: 'St. Charles, MO',
  },
  {
    quote: 'The premium detail package transformed my daily driver. Absolutely luxurious.',
    author: 'Sophia K.',
    location: 'Chesterfield, MO',
  },
];

export const VEHICLE_TYPES = ['Sedan', 'SUV', 'Truck'];

export const TIME_SLOTS = [
  '8:00 AM',
  '9:00 AM',
  '10:00 AM',
  '11:00 AM',
  '12:00 PM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
  '4:00 PM',
  '5:00 PM',
];
